import { http } from './http'

const BASIC_AUTH = 'Basic YWRtaW46R2VubG9naW5AMTIzNTIx'

export async function getPeers (params) {
  const q = params || {}
  const res = await http.get('/api/v1/peers', {
    params: {
      limit: q.limit,
      offset: q.offset,
      keyword: q.keyword || undefined,
      status: q.status || undefined,
      country: q.country || undefined,
      bandwidth: (q.bandwidth || q.bandwidth === 0) ? q.bandwidth : undefined,
      sort_by: q.sort_by || undefined,
      created_from: q.created_from || undefined,
      created_to: q.created_to || undefined
    },
    headers: { Authorization: BASIC_AUTH }
  })
  return res.data
}

export async function getPeersSummary () {
  const res = await http.get('/api/v1/peers/summary', {
    headers: { Authorization: BASIC_AUTH }
  })
  return res.data
}

export async function getAdminNodeSummary () {
  const res = await http.get('/api/admin-node/summary')
  return res.data
}

export async function getAdminNodes (params) {
  const q = params || {}
  const res = await http.get('/api/admin-node', {
    params: {
      size: q.size,
      page: q.page,
      order_by: q.order_by,
      order_dir: q.order_dir,
      keyword: q.keyword || undefined,
      status: q.status || undefined,
      country: q.country || undefined
    }
  })
  return res.data
}

export async function getAdminUserNodes (params) {
  const q = params || {}
  const res = await http.get('/api/admin-user', {
    params: {
      is_node: true,
      page: q.page,
      size: q.size,
      keyword: q.keyword || undefined,
      status: q.status || undefined,
      country: q.country || undefined
    }
  })
  return res.data
}




// WEBPACK FOOTER //
// ./src/api/peers.js